<template>
  <div class="theme-card fadeIn">
    <div class="theme-card__pic" v-if="image">
      <div class="theme-card__overlay">
        <router-link v-if="!hideLinks && themeLink" :to="themeLink" class="button">
          Learn More
          <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.59844 4.2002L11.3984 9.0002L6.59844 13.8002" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </router-link>
        <a :href="previewLink" class="button button_border" target="_blank">
          Preview Theme
          <img src="@/assets/imgs/shopify.svg" alt="Shopify ecommerce platform logo">
        </a>
      </div>
      <img
          loading="lazy"
          :srcset="image.srcset"
          :src="image.src"
          :alt="image.alt || ''"
      />
    </div>

    <div class="theme-card__about">
      <div class="theme-card__theme" v-if="!hideLinks && themeLink && themeName">
        <router-link :to="themeLink">{{ themeName }}</router-link>
      </div>

      <h3 class="theme-card__title" v-if="title && previewLink">
        <a :href="previewLink" target="_blank" rel="noopener">{{ title }}</a>
      </h3>

      <div class="theme-card__tag" v-if="tag">{{ tag }}</div>
    </div>
  </div>
</template>

<script setup>
defineProps({
  themeLink: {type: String, default: ''},
  themeName: {type: String, default: ''},
  title: {type: String, default: ''},
  previewLink: {type: String, default: ''},
  tag: {type: String, default: ''},
  image: {
    type: Object,
    default: () => ({
      srcset: '',
      src: '',
      alt: '',
    }),
  },
  hideLinks: {type: Boolean, default: false}
})
</script>

<style lang="scss">
.theme-card {
  @include xs {
    display: flex;
    flex-direction: column;
  }

  &__pic {
    position: relative;
    margin: 0 0 10px;
    overflow: hidden;
    border-radius: 24px;

    @include xs {
      display: contents;
    }
  }

  &__overlay {
    position: absolute;
    left: 0;
    top: 0;
    z-index: 2;
    opacity: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: var(--transition);
    background: rgba(0, 0, 0, .5);
    width: 100%;
    height: 100%;
    gap: .5rem;

    .button {
      &_border {
        background: #fff;

        &:hover {
          background: #fff;
        }
      }
    }

    @include xs {
      position: initial;
      background: none;
      opacity: 1;
      order: 99;
      margin: 1rem 0 0;
      flex-direction:column;

      .button {
        flex: auto;
        width:100%;
        padding: 0;
      }
    }
  }

  &__pic:hover &__overlay {
    opacity: 1;
  }

  &__about {
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    @include xs {
      position: relative;
      margin-top: 10px;
    }
  }

  &__theme {
    font-size: 0.875rem;
    letter-spacing: 0;
    margin: 0 0 4px;
    text-transform: capitalize;

    a {
      color: var(--color-main);

      &:hover {
        opacity:.6;
      }
    }
  }

  &__title {
    margin: 0 0 8px;
    text-transform: capitalize;
    font-size: 1.25rem;
    line-height:1.4;
    font-weight: 600;
    font-family:var(--font-family);

    @include xs {
      margin: 0;
    }

    a {
      color: var(--color-main);

      &:hover {
        opacity:.6;
      }
    }
  }

  &__tag {
    appearance: none;
    border: 0;
    background: var(--color-gray-light);
    font-family: var(--font-family);
    color: var(--color-accent);
    display: flex;
    align-items: center;
    height: 1.875rem;
    padding: 0 0.75rem;
    font-size: 1rem;
    text-transform: capitalize;
    border-radius: 8px;
    transition: var(--transition);

    @include xs {
      position: absolute;
      top: 0;
      right: 0;
    }
  }
}
</style>
